import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { RouteAnimation } from 'src/animations/animations';
import { Divider } from 'src/components/shared/Divider/Divider';
import { useReduxDispatch } from 'src/store';
import {
  ParameterSetDetailDto,
  ParameterSetParameterDto
} from 'src/store/parametersets/parameterset';
import { mapParameterSetDetailToEdit } from 'src/store/parametersets/parameterset.map';
import {
  createParameterSet,
  editParameterSet,
  ParameterSetTypes
} from 'src/store/parametersets/parametersets.actions';
import { ParameterSetApi } from 'src/store/parametersets/parametersets.api';
import { push } from 'src/utils/navigation';
import { StandardPractice } from './Parameters';
import { ParameterSetDetailsForm } from './ParameterSetDetailsForm';

export const ParameterSetPage = () => {
  const [parameterSet, setParameterSet] =
    useState<Nullable<ParameterSetDetailDto>>(null);

  const [parameterSetParameters, setParameterSetParameters] = useState<
    ParameterSetParameterDto[]
  >([]);

  const dispatch = useReduxDispatch();
  const { id: idParam } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetch = async () => {
      const response = await ParameterSetApi.getById(Number(idParam));
      if (response.ok) {
        setParameterSet(response.data);
      }
    };

    if (!!idParam) {
      fetch();
    }
  }, [idParam, dispatch]);

  const onCancel = () => {
    push('/parametersets', navigate, RouteAnimation.SlideLeft);
  };

  const onSubmit = async (parameterSet: ParameterSetDetailDto) => {
    const dto = mapParameterSetDetailToEdit(parameterSet);
    dto.parameterSetParameters = parameterSetParameters;
    const result = dto.id
      ? await dispatch(editParameterSet(dto.id, dto))
      : await dispatch(createParameterSet(dto));
    if (result.type !== ParameterSetTypes.Failure) {
      onCancel();
    }
  };

  return (
    <React.Fragment>
      <ParameterSetDetailsForm
        parameterSet={parameterSet}
        onCancel={onCancel}
        onSubmit={onSubmit}
      />
      <Divider />
      <StandardPractice
        parameterSet={parameterSet}
        onParametersChanged={parameters => {
          setParameterSetParameters(parameters);
        }}
      />
    </React.Fragment>
  );
};
